document.addEventListener(
    "DOMContentLoaded",
    function () {
        import("./core/details").then((module) => {
            module.init();
        });
        import("./core/group").then((module) => {
            module.init();
        });
    }
);
